module.exports = __webpack_public_path__ + "static/img/1_5.87f5c4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting674/images/1_5.png
// module id = HgwN
// module chunks = 4